import { render } from "./CardCheck.vue?vue&type=template&id=529af104"
import script from "./CardCheck.vue?vue&type=script&lang=js"
export * from "./CardCheck.vue?vue&type=script&lang=js"
script.render = render

export default script